export class VatType {
    code = null;      
    vatPercent = null; 
    fromDate = null;     
    toDate = null;     
    isUsing = true;
    isDefault = false;
}